const styles = {
  global: {
    'html, body': {
      bg: 'gray.900',
    },
  },
}


export default styles;